module.exports = __webpack_public_path__ + "assets1783936157458/img/ceshi.d2426b91.svg";